/**
 * Computes the DAT buy rate as DAT median rate + average fuel surcharge per trip,
 * rounded to the nearest cent.
 *
 * Falls back to the legacy `high_median_avg` field when `market_rate` isn't present
 * (older API responses only populated `high_median_avg`).
 *
 * Returns null when there is no usable median rate to compute from.
 */
export function computeDatBuyRate(datRates) {
    var _a, _b, _c;
    if (!datRates)
        return null;
    const fuelSurcharge = (_a = datRates.avg_fuel_surcharge_per_trip_usd) !== null && _a !== void 0 ? _a : 0;
    const datMedian = (_c = (_b = datRates.market_rate) !== null && _b !== void 0 ? _b : datRates.high_median_avg) !== null && _c !== void 0 ? _c : 0;
    return datMedian > 0 ? Math.round((datMedian + fuelSurcharge) * 100) / 100 : null;
}
